import { DariCalendarService } from '../../../services/DariCalendar';
import { Global } from '../../global';
import { KeyValuePair } from '../../../models/Utility';
import { UtilityService } from '../../../services/Acc_Utility.service';
import { GL_Category } from '../../../models/GL_Category';
import { Component, OnInit } from '@angular/core';
import { GL_Master } from '../../../models/GL_Master'
import { GL_MasterService } from '../../../services/Acc_GL_Master.service';
import { MatSnackBar } from '@angular/material';

@Component({
  selector: 'app-gl-master',
  templateUrl: './gl-master.component.html',
  styleUrls: ['./gl-master.component.css']
})  
export class GlMasterComponent implements OnInit {

  //gls: GL_Master[] ;
  gls: any;
  ArrLabels: any;
  labels: any = {};

  constructor(
    private DariCalendar: DariCalendarService,
    private GL_MasterService: GL_MasterService,
    private UtilityService: UtilityService,
    public snackBar: MatSnackBar,
    private global: Global) {

  }

  ngOnInit() {
     
    this.getBranchId();    
    this.getLabels();
  }

  isBranchId: number = -1;
  userId: string = '0';
  getBranchId() {
     
    let data = localStorage.getItem('accessKeyUser');
    let dataAccess = JSON.parse(data);
    let dataAccessUrl = dataAccess.filter(f => f.accessKeyUrl == "/expense-list")[0];
    if (dataAccessUrl != undefined) {
      if (dataAccessUrl.isMainBranch)
        this.isBranchId = 1;
      else if (dataAccessUrl.isWestBranch)
        this.isBranchId = 2;
      else
        this.isBranchId = 0;
      this.userId = dataAccessUrl.userId
    }
    this.getGls();
  }

  getGls() {
    this.GL_MasterService.getGL_Masters("All", this.isBranchId)
      .subscribe(response => {
        if (response) {
          this.gls = response;
          console.log(response);
          for (let i in this.gls) {
            this.gls[i].createDate_da = this.DariCalendar.PersianCalendar(new Date(this.gls[i].createDate));
          }
        }
      },
        error => console.log(error))

  }

  deleteGLMaster(gl_master_code: string) {
    if (!confirm("تایید؟"))
      return;

    this.GL_MasterService.DeleteGL_Master(gl_master_code)
      .subscribe(response => {

        if (response == 'notExist')
          this.openSnackBarInfo('اکانت موجود نیست', 'خطا')
        else if (response == 'hasChild')
          this.openSnackBarInfo('زیر اکانت موجود است', 'خطا')
        else {
          this.openSnackBarInfo('اکانت حذف شد', '')
          this.getGls();
        }
      }
        , error => console.log("error --> " + error));
  }

  openSnackBarInfo(message: string, action: string) {
    let snackBarRef = this.snackBar.open(message, action, {
      duration: 2000,
    });
    snackBarRef.closeWithAction = function () {
      snackBarRef.dismiss();
    }
  }

  getLabels() {
    this.UtilityService.getLabels('gl-master', this.global.lang)
      .subscribe(response => {
        if (response) {
          this.ArrLabels = response;
          this.setLabels();
        }
      },
        error => console.log(error))
  }

  setLabels() {
    this.labels['gl-master-Title'] = this.ArrLabels.find((o: any) => o.key === 'gl-master-Title').value;
    this.labels['AccountID'] = this.ArrLabels.find((o: any) => o.key === 'AccountID').value;
    this.labels['AccountName'] = this.ArrLabels.find((o: any) => o.key === 'AccountName').value;
    this.labels['AccountCategory'] = this.ArrLabels.find((o: any) => o.key === 'AccountCategory').value;
    this.labels['AccountName_en'] = this.ArrLabels.find((o: any) => o.key === 'AccountName_en').value;
    this.labels['SubAccounts'] = this.ArrLabels.find((o: any) => o.key === 'SubAccounts').value;

    // shared labels.
    this.labels['RecordStat'] = this.ArrLabels.find((o: any) => o.key === 'RecordStat').value;
    this.labels['AuthStat'] = this.ArrLabels.find((o: any) => o.key === 'AuthStat').value;
    this.labels['CreateDate'] = this.ArrLabels.find((o: any) => o.key === 'CreateDate').value;
    this.labels['CheckerID'] = this.ArrLabels.find((o: any) => o.key === 'CheckerID').value;
    this.labels['MakerID'] = this.ArrLabels.find((o: any) => o.key === 'MakerID').value;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/GLs/gl-master/gl-master.component.ts